import { LocationType } from '@wix/ambassador-bookings-services-v2-service/types';
export const mapBasketToCalendarSelections = basket => {
  const location = basket.location.type === LocationType.BUSINESS ? basket.location.value : undefined;
  return {
    location,
    services: basket.selectedServicesPreferences.map(servicePreferences => {
      var _servicePreferences$v, _servicePreferences$v2, _servicePreferences$v3;
      return {
        id: servicePreferences.service.id,
        resources: Object.values(servicePreferences.resources)[0],
        variants: servicePreferences.variant && !((_servicePreferences$v = servicePreferences.variant.choices) != null && _servicePreferences$v[0].staffMemberId) ? [{
          choices: [{
            optionId: (_servicePreferences$v2 = servicePreferences.variant.choices) == null ? void 0 : _servicePreferences$v2[0].optionId,
            custom: (_servicePreferences$v3 = servicePreferences.variant.choices) == null ? void 0 : _servicePreferences$v3[0].custom
          }]
        }] : undefined
      };
    })
  };
};
//# sourceMappingURL=mapBasketToCalendarSelections.js.map